import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black, orange } from 'constants/colors';

export const GreetingsModal = styled.div`
  width: 27rem;
  text-align: center;
  margin: 0 auto;
  position: relative;

  .confetti {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }

  .users {
    white-space: nowrap;
    margin-bottom: 1rem;

    > div {
      width: 50%;
      display: inline-block;

      &:first-child {
        text-align: left;

        .avatar_bubble {
          border: 0.3rem solid ${orange};
        }
      }
      &:last-child {
        text-align: right;
        .avatar_bubble {
          border: 0.1rem solid #000;
        }
      }
    }
  }

  .match_icon {
    margin: 1rem;
  }

  .info {
    color: ${black};
    font-size: 1.6rem;
    line-height: 2.2rem;
    strong {
      display: block;
      font-family: ${RalewayFont.semiBoldFamily};
      margin-bottom: 1rem;
    }
  }

  .buttons {
    margin-top: 2rem;
    button.primary {
      background-color: ${orange};
      color: #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/NewUserConnection/components/styles.js